// extracted by mini-css-extract-plugin
export var label = "_qv-0";
export var link = "_qv-1";